import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Function to handle auth expiration
export const handleAuthExpiration = () => {
  // Clear tokens
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  
  // Set a flag to show expiration message on login page
  sessionStorage.setItem('auth-expired', 'true');
  
  // Dispatch custom event to notify AuthContext
  window.dispatchEvent(new CustomEvent('auth-expired'));
  
  // Redirect to login page
  // Use window.location for hard redirect to ensure clean state
  window.location.href = '/login';
};

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle authentication errors - redirect to login on 401 (unauthorized)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const originalRequest = error.config;
    
    // Handle 401 (unauthorized) - token is invalid or expired
    // 403 (forbidden) means user is authenticated but lacks permission - don't clear session
    if (status === 401) {
      // Don't redirect for /auth/me endpoint - let AuthContext handle it
      // This prevents redirect loops when checking authentication status
      const isAuthMeEndpoint = originalRequest.url?.includes('/auth/me');
      
      // Only handle if we have a token (to avoid redirect loops)
      // Also skip if this is a retry request, auth/me endpoint, or if we're already on the login page
      if (
        localStorage.getItem('accessToken') && 
        !originalRequest._retry && 
        !isAuthMeEndpoint &&
        !window.location.pathname.includes('/login')
      ) {
        // Mark this request as retried to prevent infinite loops
        originalRequest._retry = true;
        handleAuthExpiration();
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;

